"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const themes_1 = require("../../../themes/themes");
const Icons_1 = require("../Icons");
const ConnectorIcon = (props) => {
    const { type = '', color = 'black', width = '14', height = '20' } = props;
    const connectorIcons = {
        chademo: (react_1.default.createElement(Icons_1.ConnectorCHAdeMO, { width: `${width}px`, height: `${height}px`, color: themes_1.theme.color[color] })),
        ccs: (react_1.default.createElement(Icons_1.ConnectorCCS, { width: `${width}px`, height: `${height}px`, color: themes_1.theme.color[color] })),
        'type 1': (react_1.default.createElement(Icons_1.ConnectorType1, { width: `${width}px`, height: `${height}px`, color: themes_1.theme.color[color] })),
        'type 2': (react_1.default.createElement(Icons_1.ConnectorType2, { width: `${width}px`, height: `${height}px`, color: themes_1.theme.color[color] })),
        '3 pin': (react_1.default.createElement(Icons_1.Connector3Pin, { width: `${width}px`, height: `${height}px`, color: themes_1.theme.color[color] })),
        commando: (react_1.default.createElement(Icons_1.ConnectorCommando, { width: `${width}px`, height: `${height}px`, color: themes_1.theme.color[color] })),
    };
    return (connectorIcons[type.toLowerCase()] || (react_1.default.createElement(Icons_1.ConnectorFallback, { width: `${width}px`, height: `${height}px`, color: themes_1.theme.color[color] })));
};
exports.default = react_1.default.memo(ConnectorIcon);
